import type { ICellRendererParams } from 'ag-grid-community'
import { iconVars } from '../utils/dom'
import { createTemplateRenderer } from '../utils/fast-renderer'

/**
 * Static icon skeleton — parsed ONCE, cloned per cell. Mirrors `iconHTML`
 * (dom.ts): `<span data-component=".icon"><i></i></span>` with the `--icon-url`
 * / `--icon-size` vars written per cell. No `<facade-icon>` custom element.
 */
const ICON_TEMPLATE = '<span data-component=".icon"><i></i></span>'

/**
 * Apply an icon name to a cloned skeleton in place — no re-parse, no re-clone.
 * Empty name → hide the span (blank cell, matching `iconHTML`'s empty output).
 */
const updateIcon = (root: HTMLElement, name: string): void => {
  const i = root.firstElementChild as HTMLElement

  if (!name) {
    root.hidden = true
    i.style.removeProperty('--icon-url')
    return
  }

  const vars = iconVars(name)

  i.style.setProperty('--icon-size', vars['--icon-size'])
  i.style.setProperty('--icon-url', vars['--icon-url'])
  root.hidden = false
}

/** Icon cell renderer — clones a pre-parsed template, no innerHTML on refresh */
export const IconComponent = createTemplateRenderer<string>(
  ICON_TEMPLATE,
  (root, name, _params: ICellRendererParams) => updateIcon(root, name)
)
